var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_15123_119253)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0347 11.6044V12.8574H9.95137C9.42664 12.8574 9 13.284 9 13.8087V19.0486C9 19.5734 9.42664 20 9.95137 20H17.2632C17.7879 20 18.2145 19.5734 18.2145 19.0486V13.8063C18.2145 13.2816 17.7879 12.8549 17.2632 12.8549H17.2387V11.602C17.2387 9.61586 15.6228 8 13.6367 8C11.6506 8.00245 10.0347 9.61831 10.0347 11.6044ZM14.1712 16.6604C14.0977 16.7143 14.0781 16.7658 14.0781 16.8517C14.0805 17.2366 14.0805 17.6191 14.0805 18.0041C14.0879 18.1635 14.0069 18.3204 13.8647 18.3915C13.5288 18.5631 13.1929 18.3228 13.1929 18.0041V18.0016C13.1929 17.6167 13.1929 17.2317 13.1953 16.8468C13.1953 16.7683 13.1782 16.7168 13.1095 16.6653C12.7613 16.4078 12.6461 15.9689 12.8202 15.584C12.9894 15.2088 13.4038 14.9881 13.7936 15.0666C14.2276 15.1549 14.5292 15.5031 14.5341 15.9371C14.5341 16.2387 14.414 16.4839 14.1712 16.6604ZM11.6114 11.6044C11.6114 10.4863 12.521 9.57908 13.6367 9.57908C14.7548 9.57908 15.662 10.4888 15.662 11.6044V12.8574H11.6114V11.6044Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15123_119253",
    x1: 34.2332,
    y1: 21.7668,
    x2: 21.7668,
    y2: -6.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD1C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6480C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/Security_Icon.ed1563db1c603c433a54b7c67e16f279.svg";
export { ForwardRef as ReactComponent };